import { useCallback, useEffect, useState } from 'react'

import checkIcon from 'assets/icons/check.svg'
import callIconWhite from 'assets/images/explore-learnings/call-icon-white.svg'
import chatIcon from 'assets/images/explore-learnings/chat-icon.svg'
import copyIcon from 'assets/images/explore-learnings/copy-icon.svg'
import locationIcon from 'assets/images/explore-learnings/location-black.svg'
import crossIcon from 'assets/images/explore-learnings/modal-cross.svg'
import { copyToClipboard, generateTeamsChatLink, generateTeamsMeetingLink } from 'utils/common'
import { useToast } from 'utils/toast'

import { TagGroup } from './TagGroup'

interface PractitionerModalProps {
  selectedPractitioner: any
  onClose: () => void
}
export const PractitionerModal = ({ selectedPractitioner, onClose }: PractitionerModalProps) => {
  const { showToast } = useToast()
  const [isCopied, setIsCopied] = useState(false)
  useEffect(() => {
    if (selectedPractitioner) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = 'unset'
    }

    return () => {
      document.body.style.overflow = 'unset'
    }
  }, [selectedPractitioner])

  const handleCopyEmail = useCallback(() => {
    if (isCopied) return
    copyToClipboard(selectedPractitioner.email)
    showToast({
      type: 'success',
      message: 'Link copied to clipboard.',
    })
    setIsCopied(true)
  }, [isCopied, selectedPractitioner.email, showToast])

  return (
    <>
      <div
        className={`${selectedPractitioner ? 'fixed' : 'hidden'} top-0 left-0 h-screen w-screen z-[999] font-TCCC bg-[#191919]/75`}
      >
        <div className="w-full h-full" onClick={() => onClose()} />
        <div className="absolute top-0 w-full h-full flex justify-center items-center pointer-events-none" />
        <div
          className="absolute top-[32%] left-[25%] bg-white w-[704px] p-6 rounded-xl pointer-events-auto flex flex-col"
          onClick={e => e.stopPropagation()}
        >
          <div className="flex justify-between">
            <h1 className="text-[28px] font-semibold leading-10">Practitioner details</h1>
            <img src={crossIcon} alt="Close" className="self-start cursor-pointer" onClick={() => onClose()} />
          </div>
          <div className="px-1 pt-8 pb-9 flex font-TCCC">
            <div className="flex flex-col mr-4 w-1/2">
              <p className="pb-1 mb-2 font-bold">{`${selectedPractitioner.name} ${selectedPractitioner.surname}`}</p>
              <p className="text-12 my-1">{selectedPractitioner.jobPosition}</p>
              <p className="flex my-1 border-b border-solid border-[#D7D7D7] pb-5">
                <img src={locationIcon} className="w-4 mr-[6px]" alt="Location" />{' '}
                <span className="body-xs">{selectedPractitioner.location}</span>
              </p>
              <p className="flex text-12 font-semibold mt-5 cursor-pointer items-center" onClick={handleCopyEmail}>
                {' '}
                <img className="w-5 mr-1 cursor-pointer" src={isCopied ? checkIcon : copyIcon} alt="Copy" /> Copy email
              </p>
            </div>
            <div className="flex flex-col">
              <p className="text-[#5F5F5F] text-[11px] font-bold">TOP SKILLS</p>
              <div className="flex max-w-[312px] mt-2 gap-x-2 gap-y-2 flex-wrap">
                <TagGroup showAll skills={selectedPractitioner.skills} />
              </div>
            </div>
          </div>
          <div className="mt-auto pt-0 flex justify-between text-14 font-bold">
            <button
              className="flex py-[8px] px-[15px]  rounded-[40px] border border-solid border-black whitespace-nowrap items-center"
              onClick={() => window.open(generateTeamsChatLink(selectedPractitioner.email))}
            >
              <span className="leading-[22px]"> Open Teams chat</span>
              <img src={chatIcon} alt="Chat" className="ml-[10px]" />
            </button>
            <button
              className="flex py-[9px] px-[14px] rounded-[40px] bg-black text-white whitespace-nowrap items-center"
              onClick={() => window.open(generateTeamsMeetingLink(selectedPractitioner.email))}
            >
              Book a call <img src={callIconWhite} alt="Call" className="ml-[10px] w-[20px]" />
            </button>
          </div>
        </div>
      </div>
    </>
  )
}
